if (process.env.NODE_ENV !== 'production') {
  require('dotenv').config()
}

export const API = process.env.WEB_API || 'http://tth.envisoft.gov.vn:8081'
export const PORT =  process.env.PORT || 5055

export function toAuthUrl(prefix = '') {
  if (prefix)
    return `${API}/${prefix}`
  return API
}

export function toUrl(prefix = '') {
  if (prefix)
    return `${API}/${prefix}`
  return API
}